// El dataset abierto trae 2 fotos (inicio/fin del movimiento), no vídeo real.
// Fundido cruzado suave entre ambas en vez de un corte duro, para que no se vea a tirones.
export function ExerciseGif({ urls, alt, className = "" }: { urls: string[]; alt: string; className?: string }) {
  if (urls.length === 0) {
    return (
      <div className={`grid place-items-center bg-bg1 font-mono text-[9px] uppercase tracking-[0.1em] text-muted ${className}`}>
        Sin imagen
      </div>
    );
  }

  return (
    <div className={`relative overflow-hidden bg-bg1 ${className}`}>
      {urls.slice(0, 2).map((url, i) => (
        <img
          key={url}
          src={url}
          alt={alt}
          className="absolute inset-0 h-full w-full object-cover exercise-gif-frame"
          style={{
            opacity: i === 0 ? 1 : 0,
            animation: urls.length > 1 ? `exercise-gif-flip 2.8s ease-in-out infinite` : undefined,
            animationDelay: `${i * 1.4}s`,
          }}
        />
      ))}
      <style>{`
        @keyframes exercise-gif-flip {
          0%   { opacity: 1 }
          50%  { opacity: 0 }
          100% { opacity: 1 }
        }
        @media (prefers-reduced-motion: reduce) {
          .exercise-gif-frame { animation: none !important; }
        }
      `}</style>
    </div>
  );
}
